import React from "react";
import "./Summary.css";

const Summary = () => {
  const CWD = ""; // Set your base path here

  return (
    <div className="summary-main-container">
      <div className="potriatImage potriatImage-mbl ">
        <img
          src={`/assets/img/gallery/dr-latest.png`}
          width="350"
          alt="Dr-Imtiaz"
        />
      </div>
      <div class="tittle-education-container col-md-9  ">
        <div
          className="tittle-education"
          style={{
            borderBottom: "1px solid #363636",

            // maxWidth: "95%",

            // margin: "10px",
            marginBottom: "20px",
          }}
        >
          <h2>Dr. Imtiaz Ahmed</h2>
          <h4> Consultant Dermatologist</h4>
        </div>
        <div className="description-summary">
          <h6>
            Dr Imtiaz Ahmed is a nationally renowned consultant dermatologist
            with vast experience of almost 30 years in managing a wide range of
            complex skin conditions. He practices in the West Midlands area at
            University Hospitals Leicester. Dr Ahmed holds private
            clinics at BMI Meriden in Coventry, Nuffield Health Warwickshire and
            Spire Hospital in Leicester, with patients travelling from all over
            the country for his expertise.
          </h6>
        </div>
      </div>
      <div className=" about-summary-inline" style={{marginTop:"50px"}}>
        <p>
          Dr Imtiaz Ahmed is a nationally renowned consultant dermatologist with
          vast experience of over 30 years in managing a wide range of complex
          skin conditions. His current NHS practice is at the University
          Hospital Leicester. He has worked the majority of his NHS career at
          University Hospital Coventry and Warwickshire NHS trust as a senior
          consultant dermatologist.
        </p>
        {/* <br /> */}
        {/* <br /> */}
        <p>
          Dr Ahmed holds private clinics at BMI Meriden in Coventry, Nuffield
          Hospital Leamington and Spire Hospital in Leicester, with patients
          travelling from all over the country for his expertise.
        </p>
        {/* <br /> */}
        {/* <br /> */}
        <p>
          Dr Ahmed treats all forms of adults skin disease, with a specialist
          interest in skin cancer. He offers both surgical and non-surgical
          treatment for skin diseases including Acne, Eczema, Psoriasis, Skin
          Cancer, Moles, Warts, Infections.
        </p>
      </div>

      <div className="caresoul-membership mb-5">
        <div
          id="carouselExampleCaptions"
          class="carousel slide"
          data-bs-ride="carousel"
        >
          <div class="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="0"
              class="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="3"
              aria-label="Slide 4"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="4"
              aria-label="Slide 5"
            ></button>
          </div>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img
                src="/diseasePic/dr-same-1.png"
                class="d-block w-100"
                alt="BMA"
              />
              <div class="carousel-caption d-none d-md-block">
                {/* <h5>First slide label</h5> */}
                {/* <p>Some representative placeholder content for the first slide.</p> */}
              </div>
            </div>
            <div class="carousel-item">
              <img
                src="/diseasePic/dr-same-2.png"
                class="d-block w-100"
                alt="MDU"
              />
              <div class="carousel-caption d-none d-md-block">
                {/* <h5>Second slide label</h5> */}
                {/* <p>Some representative placeholder content for the second slide.</p> */}
              </div>
            </div>
            <div class="carousel-item">
              <img
                src="/diseasePic/dr-same-3.png"
                class="d-block w-100"
                alt="General Medical Council"
              />
              <div class="carousel-caption d-none d-md-block">
                {/* <h5>Third slide label</h5> */}
                {/* <p>Some representative placeholder content for the third slide.</p> */}
              </div>
            </div>
            <div class="carousel-item">
              <img
                src="/diseasePic/dr-same-4.png"
                class="d-block w-100"
                alt="BSDS"
              />
              <div class="carousel-caption d-none d-md-block">
                {/* <h5>Third slide label</h5> */}
                {/* <p>Some representative placeholder content for the third slide.</p> */}
              </div>
            </div>
            <div class="carousel-item">
              <img
                src="/diseasePic/dr-same-5.png"
                class="d-block w-100"
                alt="BAD"
              />
              <div class="carousel-caption d-none d-md-block">
                {/* <h5>Third slide label</h5> */}
                {/* <p>Some representative placeholder content for the third slide.</p> */}
              </div>
            </div>
          </div>
          <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="prev"
          >
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="next"
          >
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Summary;
